import request from "./axios";

class SalesPersonTasksService {
  index(params = {}) {
    return request({
      method: "get",
      url: `/sales_person_tasks`,
      params: params
    });
  }

  create(task) {
    return request({
      method: "post",
      url: `/sales_person_tasks`,
      data: { sales_person_task: task }
    });
  }

  update(id, task) {
    return request({
      method: "patch",
      url: `/sales_person_tasks/${id}`,
      data: { sales_person_task: task }
    });
  }

  delete(id) {
    return request({
      method: "delete",
      url: `/sales_person_tasks/${id}`
    });
  }

  stats(assignee_id = null) {
    const params = assignee_id ? { assignee_id } : {};
    return request({
      method: "get",
      url: `/sales_person_tasks/stats`,
      params: params
    });
  }

  addComment(taskId, content) {
    return request({
      method: "post",
      url: `/sales_person_tasks/${taskId}/add_comment`,
      data: { content }
    });
  }

  getOptions() {
    return request({
      method: "get",
      url: `/sales_person_tasks/options`
    });
  }

  deleteType(type) {
    return request({
      method: "delete",
      url: `/sales_person_tasks/types/${encodeURIComponent(type)}`
    });
  }

  createType(name) {
    return request({
      method: "post",
      url: `/sales_person_tasks/types`,
      data: { name }
    });
  }

  getSectionsSummary(filters = {}) {
    return request({
      method: "get",
      url: `/sales_person_tasks/sections_summary`,
      params: filters
    });
  }

  bulkSendSms(taskIds) {
    return request({
      method: "post",
      url: `/sales_person_tasks/bulk_send_sms`,
      data: { task_ids: taskIds }
    });
  }

  bulkNoSale(taskIds, noSaleReason, notesNoSale) {
    return request({
      method: "post",
      url: `/sales_person_tasks/bulk_no_sale`,
      data: {
        task_ids: taskIds,
        no_sale_reason: noSaleReason,
        notes_no_sale: notesNoSale
      }
    });
  }

  getPossibleAssignees(taskId) {
    return request({
      method: "get",
      url: `/sales_person_tasks/${taskId}/possible_assignees`
    });
  }
}

export default new SalesPersonTasksService();
